import '@flaticon/flaticon-uicons/css/regular/rounded.css';
import '@flaticon/flaticon-uicons/css/solid/straight.css';
import Box from '@mui/material/Box';

// Ícones de navegação
export const NavigationIcons = Object.freeze({
  abort: 'undo',
  next: 'angle-right',
  back: 'angle-left',
  first: 'first',
  last: 'last',
  arrowUp: 'angle-up',
  arrowDown: 'angle-down',
  arrowLeft: 'angle-left',
  arrowRight: 'angle-right',
  expand: 'angle-down',
  collapse: 'angle-up',
  menu: 'menu-burger',
  exit: 'exit',
});

// Ícones de ações
export const ActionIcons = Object.freeze({
  new: 'plus',
  save: 'disk',
  delete: 'trash',
  edit: 'pencil',
  search: 'search',
  filter: 'filter',
  clearFilter: 'clear-alt',
  clear: 'eraser',
  confirm: 'check',
  synced: 'check-double',
  close: 'cross',
  refresh: 'refresh',
  restart: 'eraser',
  copy: 'copy-alt',
  print: 'print',
  actions: 'menu-dots',
});

// Ícones de status
export const StatusIcons = Object.freeze({
  approve: 'social-network',
  reprove: 'social-network',
  refuse: 'ban',
  cancelled: 'cross-circle',
  pending: 'clock-three',
  confirm: 'check',
  saleIntegrationStatusCheck: 'check-circle',
  saleIntegrationStatusError: 'cross-circle',
  saleIntegrationStatusInProgress: 'circle-half-stroke',
  shippingStatus: 'triangle-warning',
  shippingStatusCheck: 'check',
  addressLocked: 'lock',
  addressMissing: 'location-dot-slash',
});

// Ícones de sistema
export const SystemIcons = Object.freeze({
  settings: 'settings',
  system: 'wrench-alt',
  help: 'interrogation',
  news: 'megaphone',
  cpu: 'microchip',
  dashboard: 'dashboard-monitor',
  reports: 'document',
  layers: 'layers',
  menuSubItem: 'arrow-turn-down-right',
  import: 'file-import',
});

// Ícones de tempo/calendário
export const TimeIcons = Object.freeze({
  calendarBlock: 'calendar-xmark',
  calendarRange: 'calendar-minus',
  timer: 'clock',
  timerAdd: 'time-add',
  timerRemove: 'time-delete',
  timerCheck: 'time-check',
  timerAlert: 'time-forward',
  timerPending: 'time-quarter-to',
  noshow: 'time-delete',
  history: 'time-past',
});

// Ícones de estoque/logística
export const LogisticsIcons = Object.freeze({
  stock: 'boxes',
  product: 'box-open-full',
  inventory: 'inboxes',
  box: 'box-alt',
  picking: 'box-open',
  packing: 'box-open-full',
  dispatch: 'box-circle-check',
  receiving: 'truck-arrow-left',
  shipping: 'truck-arrow-right',
  truck: 'truck-side',
  stockTransfer: 'exchange',
  resupplies: 'restock',
  movement: 'person-dolly',
  tag: 'ticket',
  priority: 'priority-importance',
  lungs: 'lungs',
  transport: 'truck-check',
});

// Ícones de vendas
export const SalesIcons = Object.freeze({
  sales: 'chart-mixed-up-circle-dollar',
  quickSearch: 'magnifying-glass-wave',
  invoice: 'receipt',
  quantityRequested: 'shopping-cart',
  quantityServed: 'shopping-cart-check',
});

// Ícones de UI/Visualização
export const UIIcons = Object.freeze({
  visible: 'eye',
  noVisible: 'eye-crossed',
  toggleOn: 'toggle-on',
  toggleOff: 'toggle-off',
  fullscreen: 'screen',
  keyboard: 'keyboard',
  openKeyboard: 'keyboard-down',
  keyboardOn: 'keyboard',
  keyboardOff: 'keyboard-down',
  cameraOn: 'camera',
  cameraOff: 'camera-slash',
  inputQuantityOnlyOne: 'circle-1',
  inputQuantityMultiple: 'circle-9',
  person: 'user',
});

// Ícones de localização
export const LocationIcons = Object.freeze({
  mapPin: 'marker',
  mapLocation: 'region-pin-alt',
  target: 'bullseye',
});

// Ícones de alerta
export const AlertIcons = Object.freeze({
  warning: 'octagon-exclamation',
  alertTriangle: 'triangle-warning',
  alertCircle: 'exclamation',
});

// Ícones diversos
export const MiscIcons = Object.freeze({
  cloudUpload: 'cloud-upload-alt',
  battery0: 'battery-empty',
  inPicking: 'user-check',
});

// Export consolidado com todos os ícones (mantém compatibilidade)
export const FlatIconOptions = Object.freeze({
  ...NavigationIcons,
  ...ActionIcons,
  ...StatusIcons,
  ...SystemIcons,
  ...TimeIcons,
  ...LogisticsIcons,
  ...SalesIcons,
  ...UIIcons,
  ...LocationIcons,
  ...AlertIcons,
  ...MiscIcons,
});

const FlatIcon = ({
  icon,
  size = '16px',
  strokeCorner = 'rr',
  onClick,
  style,
  rotate,
  invertHorizontally,
  invertVertically,
}) => {
  if (!icon || !Object.values(FlatIconOptions).includes(icon)) {
    console.warn(`Ícone inválido: ${icon}`);
    return null;
  }

  let transform = `scale(${invertHorizontally ? '-1' : '1'}, ${invertVertically ? '-1' : '1'})`;

  if (icon === 'first') {
    return (
      <Box
        onClick={onClick}
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          fontSize: `${size}`,
          marginTop: !invertVertically ? '5px' : '',
          rotate: `${rotate ?? ''}`,
          transform: `${transform}`,
          ...style,
        }}>
        <i className={`fi fi-${strokeCorner}-tally-1`} />
        <i
          className={`fi fi-${strokeCorner}-angle-left`}
          style={{ marginLeft: '-18px' }}
        />
      </Box>
    );
  }

  if (icon === 'last') {
    return (
      <Box
        onClick={onClick}
        sx={{
          ...style,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          fontSize: `${size}`,
          marginTop: !invertVertically ? '5px' : '',
          rotate: `${rotate ?? ''}`,
          transform: `${transform}`,
        }}>
        <i
          className={`fi fi-${strokeCorner}-angle-right`}
          style={{ marginRight: '-3px' }}
        />
        <i className={`fi fi-${strokeCorner}-tally-1`} />
      </Box>
    );
  }

  return (
    <i
      className={`fi fi-${strokeCorner}-${icon}`}
      onClick={onClick}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        fontSize: `${size}`,
        lineHeight: 1,
        rotate: `${rotate ?? ''}`,
        transform: `${transform}`,
        ...style,
      }}
    />
  );
};

export default FlatIcon;
